import { useConsentIdentityForm } from '../use-consent-identity-form';
import {
  BaseDialog,
  DialogAction,
} from '../../../stories/dialogs/shared/components/BaseDialog';
import { useTranslation } from 'react-i18next';
import { ControlledDateField, ControlledTextField } from '@act/storybook';

interface Props {
  open: boolean;
  handleClose: () => void;
}

const ConsentIdentityForm = ({ open, handleClose }: Props) => {
  const { t } = useTranslation();

  const {
    formState,
    onSubmit: onSubmitForm,
    control,
  } = useConsentIdentityForm({});

  const actions: DialogAction = {
    text: t('consentForm.continueToConsent'),
    buttonColor: 'primary',
    callback: onSubmitForm,
    isPrimary: true,
    disabled: !!formState.isSubmitting,
  };

  const formComponent = (
    <div>
      <div className="identity-form-row">
        <ControlledTextField
          control={control}
          label={t('consentForm.memberName')}
          name="name"
          required
        />
      </div>
      <div className="identity-form-row col-2">
        <ControlledDateField
          control={control}
          inputType="date"
          label={t('consentForm.dateOfBirth')}
          name="dateOfBirth"
          disablePast={false}
          required
        />
        <ControlledTextField
          control={control}
          label={t('consentForm.memberEmail')}
          name="email"
        />
      </div>
      <div className="identity-form-row">
        <ControlledTextField
          control={control}
          label={t('consentForm.memberStreetAddress')}
          name="line1"
        />
      </div>
      <div className="identity-form-row">
        <ControlledTextField
          control={control}
          label={t('consentForm.city')}
          name="city"
        />
      </div>
      <div className="identity-form-row col-2">
        <ControlledTextField
          control={control}
          label={t('consentForm.state')}
          name="state"
        />
        <ControlledTextField
          control={control}
          label={t('consentForm.zip')}
          name="zip"
        />
      </div>
    </div>
  );

  return (
    <BaseDialog
      open={open}
      title={'Member Identity Confirmation'}
      actions={[actions]}
      children={formComponent}
      setOpen={handleClose}
    />
  );
};

export default ConsentIdentityForm;
